import {
  USER_DELETE,
  USER_FETCH,
  USER_IN_PROCESS,
  USER_LOGGED_IN,
  USER_LOGGED_OUT,
  USER_OFFLINE,
  USER_ONLINE,
  USER_OVERLAY_OPEN,
  USER_PASSWORD_NEW,
  USER_PASSWORD_REQUEST,
  USER_SET_MODE,
  USER_SIGNUP
} from "../constants/actionTypes";
import {MODE_B2C_FULL_FEATURE} from "../constants";

const defaultState = {
  id: "",
  // Combination of firstname and lastname or no-name
  name: "",
  email: "",
  firstname: "",
  lastname: "",
  isLoggedIn: false,
  inProcess: false,
  isOnline: true,
  isFetched: false,
  mode: MODE_B2C_FULL_FEATURE
};

export const userReducer = (state = defaultState, action) => {
  switch (action.type) {
    case USER_LOGGED_IN:
      return {
        ...state,
        isLoggedIn: true,
        email: action.payload.email
      };
    case USER_ONLINE:
      return {
        ...state,
        isOnline: true
      };
    case USER_OFFLINE:
      return {
        ...state,
        isOnline: false
      };
    case USER_IN_PROCESS:
      return {
        ...state,
        inProcess: true
      };
    case USER_FETCH:
      return {
        ...state,
        ...action.payload,
        isFetched: true
      };
    case USER_DELETE:
    case USER_LOGGED_OUT:
      return defaultState;
    case USER_OVERLAY_OPEN:
      return {
        ...state,
        visible: action.payload
      };
    case USER_PASSWORD_REQUEST:
      return {...state};
    case USER_SIGNUP:
      return {...state};
    case USER_PASSWORD_NEW:
      return {...state};
    case USER_SET_MODE:
      return {...state, mode: action.payload};
    default:
      return state;
  }
};
